import React from 'react'
import { Checkbox } from '@mui/material'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import CustomAccordion from './utils/CustomAccordion'
import { useIntl } from 'react-intl'
import { observer } from 'mobx-react'
import { isLooker } from '../../../services/AccountService'

const IsSuspicious = ({ onChange, data }) => {
  const intl = useIntl()
  const handleOnClick = isLooker() ? undefined : () => onChange(true)

  return (
    <CustomAccordion
      summary={intl.formatMessage({ id: 'Подозрительная заявка' })}
      defaultOpenState={false}
    >
      <Box
        className={'fx-nowrap aln-center'}
        sx={{ cursor: 'pointer' }}
        onClick={handleOnClick}
      >
        <Checkbox checked={data.isSuspicious} disabled={isLooker()} />
        <Typography variant={'subtitle1'}>
          {intl.formatMessage({ id: 'Отметить как подозрительную заявку' })}
        </Typography>
      </Box>
    </CustomAccordion>
  )
}

export default observer(IsSuspicious)
